
  import { defineComponent } from 'vue';
  import { Icon } from '@voximplant/spaceui';
  export default defineComponent({
    name: 'DownloadedFiles',
    components: {
      Icon,
    },
  });
